import { DepartmentsEnum } from '@moonpig/web-shared-types-graphql'
import {
  departmentToVariantLabelMap,
  VariantLabel,
} from '../../utils/getVariantLabel/getVariantLabel'
import { useLocaleText } from './ProductTile.locale'

export enum ProductTileCtaEnum {
  SelectAmount = 'select-amount',
  SelectSize = 'select-size',
  AddToCard = 'add-to-card',
  Personalise = 'personalise',
  AddToBasket = 'add-to-basket',
}

export type ProductTileCtaParams = {
  department: DepartmentsEnum
  isPrintedInCard: boolean
  hasMultipleVariants: boolean
  isCustomisable: boolean
}

export const getProductTileCtaType = ({
  department,
  isPrintedInCard,
  hasMultipleVariants,
  isCustomisable,
}: ProductTileCtaParams): ProductTileCtaEnum => {
  const variantLabel = departmentToVariantLabelMap[department]
  if (isPrintedInCard && !hasMultipleVariants) {
    return ProductTileCtaEnum.AddToCard
  }
  if (isPrintedInCard && hasMultipleVariants) {
    return ProductTileCtaEnum.SelectAmount
  }
  if (hasMultipleVariants && variantLabel === VariantLabel.Size) {
    return ProductTileCtaEnum.SelectSize
  }
  if (isCustomisable) {
    return ProductTileCtaEnum.Personalise
  }

  return ProductTileCtaEnum.AddToBasket
}

export const getProductTileCtaLabel = (
  params: ProductTileCtaParams,
  localiseText: ReturnType<typeof useLocaleText>,
): string => {
  const ctaType = getProductTileCtaType(params)

  switch (ctaType) {
    case ProductTileCtaEnum.SelectAmount:
      return localiseText('non_card_product_tile.select_amount')
    case ProductTileCtaEnum.SelectSize:
      return localiseText('non_card_product_tile.select_size')
    case ProductTileCtaEnum.AddToCard:
      return localiseText('common.add_to_card')
    case ProductTileCtaEnum.Personalise:
      return localiseText('common.personalise')
    case ProductTileCtaEnum.AddToBasket:
      return localiseText('common.add_to_basket_cta')
  }
}
